import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/datasources/connectInspect';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

// Test + introspect a connector. Every source type (DB, warehouse, S3 file
// groups, Kafka topics, REST, SaaS) returns mapper-ready tables; the
// zero-table create below is only a fallback for genuinely empty sources.
function* operation(action) {
  const body = action.payload.body;
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/inspect`,
      body,
      { headers: getLocalUser() },
    );
    const data = res.data?.data || res.data;

    if (data.status === 'failed' || (data.test && data.test.success === false)) {
      // Connection test failed inside a 2xx envelope — the component reads
      // data.test / data.status and shows the credentials hint.
      yield put(fetchSuccess(data));
      return;
    }

    const tbls = data.tables || [];
    if (tbls.length === 0) {
      try {
        const createBody = { ...body, name: data.label, import_historical: false, tables: [] };
        const createRes = yield call(
          axios.post,
          `${config.API_URL}/ingestion/connect/create`,
          createBody,
          { headers: getLocalUser() },
        );
        const out = createRes.data?.data || createRes.data;
        yield put(fetchSuccess({ ...data, created: out }));
      } catch (error) {
        yield put(ErrorAction(error));
        yield put(fetchFailure(error.response?.data?.error || error.message || 'Failed to connect.'));
      }
      return;
    }

    yield put(fetchSuccess(data));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message || 'Something went wrong.'));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
